import { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/SiteManagement/Form/PotentialVariationOrderForm/index'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import {
    v2_ships,
} from '../../../actions/v2/projectAndVessel';

import Swal from 'sweetalert2';
import { v2_yards } from '../../../actions/v2/masterData';
import { v2_user_by_roles } from '../../../actions/v2/user';
import { v3_fetchNewBuildingotentialVariationOrderFormFields, v3_fetchNewBuildingSiteQueryFields, v3_submitNewBuildinPotentialVariationOrderForm, v3_submitNewBuildinSiteQuery } from '../../../actions/v3/siteManagement';

const NewBuildingBlockInspectionStatus = (props) => {
    const location = useLocation();
    const { data } = location.state || {};

    const [state, setState] = useState({
        contract_clause: { name: 'contract_clause', value: '', error: '', isRequired: true },
        specification_reference: { name: 'specification_reference', value: '', error: '', isRequired: true },
        drawing_number: { name: 'drawing_number', value: '', error: '', isRequired: true },
        standard_reference: { name: 'standard_reference', value: '', error: '', isRequired: true },
        other: { name: 'other', value: '', error: '', isRequired: false },
        estimated_cost_impact: { name: 'estimated_cost_impact', value: '', error: '', isRequired: false },
        estimated_time_impact: { name: 'estimated_time_impact', value: '', error: '', isRequired: false },
        other_possible_consequenses: { name: 'other_possible_consequenses', value: '', error: '', isRequired: true },
        description: { name: 'description', value: '', error: '', isRequired: true },

    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value,
                error: '', // Optionally clear error on change
            },
        }));
    };

    const [commonDetails, setCommonDetails] = useState({
        ship: { value: '', options: [], error: '' },
        date: { value: '', error: '' },
        finalSubmit: { value: false },
        owner: { value: '' },
        yard: { value: '', options: [], },
        yardReference: { value: '', options: [] },
        originatedBy: { value: '', options: [] },
        sq_reference_number: { value: '' },
        subject: { value: '' }
    });

    const [showLoader, setShowLoader] = useState(false);

    // Load projects
    useEffect(() => {
        v2_user_by_roles().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    originatedBy: { ...prev.originatedBy, options: res.result },
                }));
            }
        });
        v2_yards().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    yard: { ...prev.yard, options: res.result },
                }));
            }
        })
    }, []);

    // Load ships when project changes
    useEffect(() => {
        if (commonDetails.yard.value) {
            v2_ships(null, null, commonDetails.yard.value).then((res) => {
                if (res.status) {
                    setCommonDetails((prev) => ({
                        ...prev,
                        ship: { ...prev.ship, options: res.result },
                    }));
                }
            });
        } else {
            setCommonDetails((prev) => ({
                ...prev,
                ship: { value: '', options: [] },
            }));
        }
    }, [commonDetails.yard.value]);

    useEffect(() => {
        const params = data ? JSON.parse(atob(data)) : null;

        if (params) {
            setShowLoader(true);

            v3_fetchNewBuildingotentialVariationOrderFormFields(params.FORM_ID)
                .then((res) => {
                    if (res.status) {
                        const { records } = res.result;
                        
                        // Set common details
                        if (params.FORM_ID) {
                            setCommonDetails((prev) => ({
                                ...prev,
                                yard: { ...prev.yard, value: res.result.commonDetails?.YARD_ID || '' },
                                ship: { ...prev.ship, value: res.result.commonDetails?.SHIP_ID || '' },
                                date: { ...prev.date, value: res.result.commonDetails?.SUBMISSION_DATE || '' },
                                finalSubmit: { ...prev.finalSubmit, value: Boolean(res.result.commonDetails?.FINAL_SUBMITTED) },
                                originatedBy: { ...prev.originatedBy, value: res.result.commonDetails?.ORIGINATED_BY || '' },
                                yardReference: { ...prev.yardReference, value: res.result.commonDetails?.YARD_REFERENCE || '' },
                                sq_reference_number: { ...prev.sq_reference_number, value: res.result.commonDetails?.REFERENCE_NUMBER || '' },
                                subject: { ...prev.subject, value: res.result.commonDetails?.SUBJECT || '' },
                            }));

                            // Set state fields
                            
                            setState((prev) => ({
                                ...prev,
                                contract_clause: { ...prev.contract_clause, value: records?.CONTRACT_CLAUSE || '' },

                                specification_reference: { ...prev.specification_reference, value: records?.SPECIFICATION_REFERENCE || '' },
                                drawing_number: { ...prev.drawing_number, value: records?.DRAWING_NUMBER || '' },
                                standard_reference: { ...prev.standard_reference, value: records?.STANDARDS_REFERENCE || '' },
                                other: { ...prev.other, value: records?.OTHER || '' },
                                estimated_cost_impact: { ...prev.estimated_cost_impact, value: records?.ESTIMATED_COST_IMPACT || '' },
                                estimated_time_impact: {
                                    ...prev.estimated_time_impact,
                                    value: records?.ESTIMATED_TIME_IMPACT || ''
                                },

                                other_possible_consequenses: {
                                    ...prev.other_possible_consequenses,
                                    value: records?.OTHER_POSSIBLE_CONSEQUESNSES || ''
                                },

                                description: {
                                    ...prev.description,
                                    value: records?.DESCRIPTION || ''
                                },
                            }));

                        }

                    } else {
                        toast.error(res.error || 'Error fetching NCR form data');
                    }
                })
                .catch(() => {
                    toast.error('Something went wrong while fetching.');
                })
                .finally(() => {
                    setShowLoader(false);
                });
        }
    }, []);


    const onSubmit = async () => {
        
        // 1. Validation

        const errors = [];
        if (!commonDetails.yard.value) errors.push('Select a yard.');
        if (!commonDetails.ship.value) errors.push('Select a ship.');
        if (!commonDetails.sq_reference_number.value) errors.push('Enter a reference number.');
        if (!commonDetails.date.value) errors.push('Select a date.');
        if (!commonDetails.subject.value) errors.push('Enter a subject.');
        if (!commonDetails.yardReference.value) errors.push('Enter a yard reference.');
        if (!commonDetails.originatedBy.value) errors.push('Select the originator.');


        // Validate each row
        if (commonDetails.finalSubmit.value) {
            Object.entries(state).forEach(([key, field]) => {

                const isRequired = field.isRequired; // Enforce all fields if finalSubmit is true
                if (isRequired && !field.value) {
                    errors.push(`${key.replace(/_/g, ' ')} is required.`);
                }
            });
        }



        if (errors.length > 0) {
            toast.error(errors.join('\n'));
            return;
        }
        // If final submit is true, confirm before proceeding
        if (commonDetails.finalSubmit.value) {
            const confirmResult = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the reports for Office Review?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it',
                cancelButtonText: 'Cancel',
            });
            if (!confirmResult.isConfirmed) return;
        }


        const formattedRow = {};
        Object.keys(state).forEach((key) => {
            formattedRow[key] = state[key].value;
        });


        // 3. Build full payload
        const payload = {
            commonDetails: {
                yard: commonDetails.yard.value,
                ship: commonDetails.ship.value,
                date: commonDetails.date.value,
                finalSubmit: commonDetails.finalSubmit.value,
                owner: commonDetails.owner.value,
                yardReference: commonDetails.yardReference.value,
                originatedBy: commonDetails.originatedBy.value,
                sq_reference_number: commonDetails.sq_reference_number.value,
                subject: commonDetails.subject.value,
            },
            checklistItems: formattedRow,
        };

        // 4. Submit
        setShowLoader(true);
        v3_submitNewBuildinPotentialVariationOrderForm(payload)
            .then((res) => {
                setShowLoader(false);
                if (res.status) {
                    toast.success(res.result.message || 'Submitted successfully!');
                    props.history.push(constant.Authedcomponent.submittedNewBuildingPotentialVariationOrderForm.url);
                } else {
                    toast.error(res.error || 'Submission failed.');
                }
            })
            .catch((err) => {
                setShowLoader(false);
                toast.error('Submission failed.');
                console.error('Submit Error:', err);
            });
    };
    useEffect(() => {
        const selected = commonDetails.ship.options.find(
            (i) => i.ID == commonDetails.ship.value
        );

        if (selected) {
            setCommonDetails((prev) => ({
                ...prev,
                owner: {
                    ...prev.owner,
                    value: selected.OWNER_NAME || ''
                },
            }));
        }
        else {
            setCommonDetails((prev) => ({
                ...prev,
                owner: {
                    ...prev.owner,
                    value: ''
                },
            }));
        }
    }, [commonDetails.ship.value, commonDetails.ship.options]);


    return (
        <Layout title="(Potential) Variation Order Form">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>(Potential) Variation Order Form
                                            </h4>
                                            <p>
                                                Following to be checked and confirmed before official delivery
                                                of the vessel
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="report-index-top">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="hd-s2">
                                                        <p>Yard</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <div className="hull-select-box">
                                                            <select
                                                                className="form-select"
                                                                value={commonDetails.yard.value}
                                                                disabled={data ? true : false}
                                                                onChange={(e) =>
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        yard: { ...prev.yard, value: e.target.value },
                                                                    }))
                                                                }
                                                            >

                                                                <option value={''}>Select Yard</option>
                                                                {commonDetails.yard.options.map((item) => {
                                                                    return (<option value={item.ID}>{item.YARD_NAME}</option>)
                                                                })}
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Hull No</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <div className="hull-select-box">
                                                            <select
                                                                className="form-select"
                                                                disabled={data ? true : false}
                                                                value={commonDetails.ship.value}
                                                                onChange={(e) => {
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        ship: { ...prev.ship, value: e.target.value }
                                                                    }));
                                                                }}


                                                            >

                                                                <option value={''}>Select Hull</option>
                                                                {commonDetails.ship.options.map((item) => {
                                                                    return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                                                })}
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Owner</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={commonDetails.owner.value}
                                                            placeholder='Autofill'
                                                            disabled
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="hd-s2">
                                                        <p>Date</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={commonDetails.date.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    date: { ...prev.date, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                    <td className="hd-s2 pl10 w150">
                                                        <p>Originated By</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            disabled={data ? true : false}
                                                            value={commonDetails.originatedBy.value}
                                                            onChange={(e) => {
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    originatedBy: { ...prev.originatedBy, value: e.target.value }
                                                                }));
                                                            }}


                                                        >

                                                            <option value={''}>Sent To</option>
                                                            {commonDetails.originatedBy.options.map((item) => {
                                                                return (<option value={item.USER_ID}>{item.FULL_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Yard Reference</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Yard Reference"

                                                            value={commonDetails.yardReference.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    yardReference: { ...prev.yardReference, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>

                                                    <td className="hd-s2 pl10">
                                                        <p>Site Query ref No</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="(NCR/ Hull No/ NNNN)"
                                                            value={commonDetails.sq_reference_number.value}
                                                            name={commonDetails.sq_reference_number.name}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    sq_reference_number: { ...prev.sq_reference_number, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Subject</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="(Give brief description)"
                                                            value={commonDetails.subject.value}
                                                            name={commonDetails.subject.name}

                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    subject: { ...prev.subject, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="note-info">
                                        <p>Enter date of issue/ Reference No/ Suject as above in NCR Index</p>
                                    </div>
                                </div>
                            </div>

                            <Form
                                onChange={handleChange}
                                state={state}
                                onSubmit={onSubmit}
                                isFinalSubmitting={commonDetails.finalSubmit.value}
                                setIsFinalSubmitting={() => setCommonDetails((prev) => ({
                                    ...prev,
                                    finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                                }))}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NewBuildingBlockInspectionStatus